import { render, staticRenderFns } from "./DeletePhoto.vue?vue&type=template&id=72fc2d23&scoped=true&"
import script from "./DeletePhoto.vue?vue&type=script&lang=js&"
export * from "./DeletePhoto.vue?vue&type=script&lang=js&"
import style0 from "./DeletePhoto.vue?vue&type=style&index=0&id=72fc2d23&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fc2d23",
  null
  
)

component.options.__file = "DeletePhoto.vue"
export default component.exports